import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, Mail, MapPin, Phone, Facebook, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="flex items-center justify-center w-9 h-9 bg-blue-600 rounded-lg">
                <Plane className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-bold text-white">AirDelayClaim</span>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-5 text-sm">
              Your trusted partner for flight delay compensation. We help passengers claim up to €600 under EU regulations.
            </p>
            <div className="flex gap-3">
              <Link to="/404" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-300">
                <Facebook className="w-4 h-4" />
              </Link>
              <Link to="/404" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-300">
                <Linkedin className="w-4 h-4" />
              </Link>
              <Link to="/404" className="w-9 h-9 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-300">
                <Instagram className="w-4 h-4" />
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5">Quick Links</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/#how-it-works" className="text-sm hover:text-blue-400 transition-colors duration-300">How It Works</a>
              </li>
              <li>
                <a href="/#benefits" className="text-sm hover:text-blue-400 transition-colors duration-300">Benefits</a>
              </li>
              <li>
                <a href="/#faq" className="text-sm hover:text-blue-400 transition-colors duration-300">FAQ</a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5">Legal</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/terms" className="text-sm hover:text-blue-400 transition-colors duration-300">Terms of Service</Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm hover:text-blue-400 transition-colors duration-300">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm hover:text-blue-400 transition-colors duration-300">Cookie Policy</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:info@airdelayclaim.com" className="text-sm hover:text-blue-400 transition-colors duration-300">
                  info@airdelayclaim.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+442038086888" className="text-sm hover:text-blue-400 transition-colors duration-300">
                  +44 20 3808 6888
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  207 Old Bath Road<br />
                  Hounslow, London TW5 9AW, UK
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5">
          <p className="text-gray-400 text-xs text-center">
            © {currentYear} AirDelayClaim. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
